/**
 * Swagger Lucor
 * Swagger Lucor
 *
 * OpenAPI spec version: 1.2.18
 * Contact: roger.cazangi@hotmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AvaliadoFavorito } from '../model/avaliadoFavorito';
import { CargoAvaliadoFavorito } from '../model/cargoAvaliadoFavorito';
import { ListagemFavoritos } from '../model/listagemFavoritos';
import { NewListagemFavoritos } from '../model/newListagemFavoritos';
import { UpdListagemFavoritos } from '../model/updListagemFavoritos';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';

import { environment } from '../../environments/environment';

@Injectable()
export class FavoritosApiService {

    protected basePath = environment.apiBasePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Remover Cargo do Avaliado da Listagem de Favoritos
     * 
     * @param avaliadoListagemId 
     * @param cargoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdDelete(avaliadoListagemId: number, cargoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdDelete(avaliadoListagemId: number, cargoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdDelete(avaliadoListagemId: number, cargoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdDelete(avaliadoListagemId: number, cargoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliadoListagemId === null || avaliadoListagemId === undefined) {
            throw new Error('Required parameter avaliadoListagemId was null or undefined when calling v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdDelete.');
        }

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/favoritos/listagens/avaliados/${encodeURIComponent(String(avaliadoListagemId))}/cargos/${encodeURIComponent(String(cargoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Adicionar Cargo ao Avaliado da Listagem de Favoritos
     * 
     * @param avaliadoListagemId 
     * @param cargoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdPost(avaliadoListagemId: number, cargoId: number, observe?: 'body', reportProgress?: boolean): Observable<CargoAvaliadoFavorito>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdPost(avaliadoListagemId: number, cargoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CargoAvaliadoFavorito>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdPost(avaliadoListagemId: number, cargoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CargoAvaliadoFavorito>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdPost(avaliadoListagemId: number, cargoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliadoListagemId === null || avaliadoListagemId === undefined) {
            throw new Error('Required parameter avaliadoListagemId was null or undefined when calling v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdPost.');
        }

        if (cargoId === null || cargoId === undefined) {
            throw new Error('Required parameter cargoId was null or undefined when calling v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosCargoIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<CargoAvaliadoFavorito>('post',`${this.basePath}/v1/favoritos/listagens/avaliados/${encodeURIComponent(String(avaliadoListagemId))}/cargos/${encodeURIComponent(String(cargoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Cargos do Avaliado da Listagem de Favoritos
     * 
     * @param avaliadoListagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosGet(avaliadoListagemId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CargoAvaliadoFavorito>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosGet(avaliadoListagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CargoAvaliadoFavorito>>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosGet(avaliadoListagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CargoAvaliadoFavorito>>>;
    public v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosGet(avaliadoListagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (avaliadoListagemId === null || avaliadoListagemId === undefined) {
            throw new Error('Required parameter avaliadoListagemId was null or undefined when calling v1FavoritosListagensAvaliadosAvaliadoListagemIdCargosGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CargoAvaliadoFavorito>>('get',`${this.basePath}/v1/favoritos/listagens/avaliados/${encodeURIComponent(String(avaliadoListagemId))}/cargos`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Listagens de Favoritos
     * 
     * @param withoutChildren 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensGet(withoutChildren?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ListagemFavoritos>>;
    public v1FavoritosListagensGet(withoutChildren?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ListagemFavoritos>>>;
    public v1FavoritosListagensGet(withoutChildren?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ListagemFavoritos>>>;
    public v1FavoritosListagensGet(withoutChildren?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (withoutChildren !== undefined && withoutChildren !== null) {
            queryParameters = queryParameters.set('withoutChildren', <any>withoutChildren);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ListagemFavoritos>>('get',`${this.basePath}/v1/favoritos/listagens`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remover Avaliado da Listagem de Favoritos
     * 
     * @param listagemId 
     * @param avaliadoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdDelete(listagemId: number, avaliadoId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdDelete(listagemId: number, avaliadoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdDelete(listagemId: number, avaliadoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdDelete(listagemId: number, avaliadoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listagemId === null || listagemId === undefined) {
            throw new Error('Required parameter listagemId was null or undefined when calling v1FavoritosListagensListagemIdAvaliadosAvaliadoIdDelete.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1FavoritosListagensListagemIdAvaliadosAvaliadoIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/favoritos/listagens/${encodeURIComponent(String(listagemId))}/avaliados/${encodeURIComponent(String(avaliadoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Adicionar Avaliado à Listagem de Favoritos
     * 
     * @param listagemId 
     * @param avaliadoId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdPost(listagemId: number, avaliadoId: number, observe?: 'body', reportProgress?: boolean): Observable<AvaliadoFavorito>;
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdPost(listagemId: number, avaliadoId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AvaliadoFavorito>>;
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdPost(listagemId: number, avaliadoId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AvaliadoFavorito>>;
    public v1FavoritosListagensListagemIdAvaliadosAvaliadoIdPost(listagemId: number, avaliadoId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listagemId === null || listagemId === undefined) {
            throw new Error('Required parameter listagemId was null or undefined when calling v1FavoritosListagensListagemIdAvaliadosAvaliadoIdPost.');
        }

        if (avaliadoId === null || avaliadoId === undefined) {
            throw new Error('Required parameter avaliadoId was null or undefined when calling v1FavoritosListagensListagemIdAvaliadosAvaliadoIdPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AvaliadoFavorito>('post',`${this.basePath}/v1/favoritos/listagens/${encodeURIComponent(String(listagemId))}/avaliados/${encodeURIComponent(String(avaliadoId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar Avaliados da Listagem de Favoritos
     * 
     * @param listagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensListagemIdAvaliadosGet(listagemId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AvaliadoFavorito>>;
    public v1FavoritosListagensListagemIdAvaliadosGet(listagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AvaliadoFavorito>>>;
    public v1FavoritosListagensListagemIdAvaliadosGet(listagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AvaliadoFavorito>>>;
    public v1FavoritosListagensListagemIdAvaliadosGet(listagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listagemId === null || listagemId === undefined) {
            throw new Error('Required parameter listagemId was null or undefined when calling v1FavoritosListagensListagemIdAvaliadosGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<AvaliadoFavorito>>('get',`${this.basePath}/v1/favoritos/listagens/${encodeURIComponent(String(listagemId))}/avaliados`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Excluir Listagem de Favoritos
     * 
     * @param listagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensListagemIdDelete(listagemId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public v1FavoritosListagensListagemIdDelete(listagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public v1FavoritosListagensListagemIdDelete(listagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public v1FavoritosListagensListagemIdDelete(listagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listagemId === null || listagemId === undefined) {
            throw new Error('Required parameter listagemId was null or undefined when calling v1FavoritosListagensListagemIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/v1/favoritos/listagens/${encodeURIComponent(String(listagemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obter Listagem de Favoritos pelo Id
     * 
     * @param listagemId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensListagemIdGet(listagemId: number, observe?: 'body', reportProgress?: boolean): Observable<ListagemFavoritos>;
    public v1FavoritosListagensListagemIdGet(listagemId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ListagemFavoritos>>;
    public v1FavoritosListagensListagemIdGet(listagemId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ListagemFavoritos>>;
    public v1FavoritosListagensListagemIdGet(listagemId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listagemId === null || listagemId === undefined) {
            throw new Error('Required parameter listagemId was null or undefined when calling v1FavoritosListagensListagemIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ListagemFavoritos>('get',`${this.basePath}/v1/favoritos/listagens/${encodeURIComponent(String(listagemId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Atualizar Listagem de Favoritos
     * 
     * @param listagemId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensListagemIdPut(listagemId: number, body?: UpdListagemFavoritos, observe?: 'body', reportProgress?: boolean): Observable<ListagemFavoritos>;
    public v1FavoritosListagensListagemIdPut(listagemId: number, body?: UpdListagemFavoritos, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ListagemFavoritos>>;
    public v1FavoritosListagensListagemIdPut(listagemId: number, body?: UpdListagemFavoritos, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ListagemFavoritos>>;
    public v1FavoritosListagensListagemIdPut(listagemId: number, body?: UpdListagemFavoritos, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listagemId === null || listagemId === undefined) {
            throw new Error('Required parameter listagemId was null or undefined when calling v1FavoritosListagensListagemIdPut.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ListagemFavoritos>('put',`${this.basePath}/v1/favoritos/listagens/${encodeURIComponent(String(listagemId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Incluir Nova Listagem de Favoritos
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public v1FavoritosListagensPost(body?: NewListagemFavoritos, observe?: 'body', reportProgress?: boolean): Observable<ListagemFavoritos>;
    public v1FavoritosListagensPost(body?: NewListagemFavoritos, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ListagemFavoritos>>;
    public v1FavoritosListagensPost(body?: NewListagemFavoritos, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ListagemFavoritos>>;
    public v1FavoritosListagensPost(body?: NewListagemFavoritos, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ListagemFavoritos>('post',`${this.basePath}/v1/favoritos/listagens`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
